import React from "react"

import { AppIncExSelect } from "@components"
import { excludeProviders } from "@signals"


export default function AppCommonFiltersExcludeProvidersSelect({ ...props }) {
	return <AppIncExSelect
		value={excludeProviders.value}
		onChange={e => excludeProviders.value = e.target.value}
		{...props}
	/>
}